import { html, css } from '~/lib/bn-lit-element';

import { sharedStyles } from '../styles/shared-styles';
import { AddToHomeScreenButton } from './a2hs-button';
import '../common/bn-surface';

class AddToHomeScreenSurface extends AddToHomeScreenButton {
  static get styles() {
    return [sharedStyles, css`
      :host {
        display: block;
      }
    `];
  }

  render() {
    if (!this.show) {
      return html``;
    }
    return html`
      <bn-surface>
        <p>Add BinSentry to your home screen.</p>
        ${super.render()}
      </bn-surface>
    `;
  }
}

window.customElements.define('a2hs-surface', AddToHomeScreenSurface);
